import { useDispatch, useSelector } from "react-redux";
import Walls from ".././Walls";
import Floor from ".././Floor";
import { useCallback, useState, useRef, memo, useEffect, useMemo } from "react";
import * as THREE from 'three';
import Ceiling from ".././Ceiling";
import { TwoDRoomLayout } from "@/store/builderSlice";
import BuilderSelect from "@/store/builderStoreSelector";
import ThreeDLayoutWallRenderer from "./ThreeDLayoutWallRenderer";
import { useThree } from "@react-three/fiber";
import { DimensionalViewType, ProductPlacementType, SurfaceType } from "@/utils/builder/builderConstants";
import { actions as builderActions } from "@/store/builderSlice";
import ThreeDLayoutWallsRenderer from "./ThreeDLayoutWallsRenderer";
import { Line } from '@react-three/drei';
import { useGLTF } from "@react-three/drei";
import { GLTFExporter } from 'three-stdlib';
import {useRouter} from 'next/router'
import { getUserId, setUserId } from "@/utils/builder/userUtils";
import axios from "axios";
import { BakedRoomModel } from "../RoomViewRenderer";
export interface ThreeDRoomLayoutRendererProps {
    // roomModelLoaded: Function;
    toggleControls: Function;
    updateCameraPosition: Function;
}

const ThreeDRoomLayoutRenderer: React.FC<ThreeDRoomLayoutRendererProps> = (
    { toggleControls, updateCameraPosition }) => {
    const dispatch = useDispatch();
    const scene = useThree((state) => state.scene);
    //const [roomBoundingBox, setRoomBoundingBox] = useState(new THREE.Box3());
    const centerRef = useRef(new THREE.Vector3());
    const floorGeometryRef = useRef<any>();
    const floorMeshRef = useRef<THREE.Mesh | undefined>(undefined);
    const twoDRoomLayout: TwoDRoomLayout = BuilderSelect.twoDRoomLayout();
    const urlParams: { [key: string]: string } = BuilderSelect.ui().urlParams;
    const isEditFlow = urlParams.projectId != null;
    const is2DView: boolean = BuilderSelect.ui().dimensionalView === DimensionalViewType.TWO_D;
    const METER_TO_INCHES_FACTOR = 39.3701;
    const meter_factor = 0.3048; // 1 ft = 0.3048 meter
    const isPreviewMode = BuilderSelect.ui().viewMode === 'preview';
    const [isBakedGLBReady, setIsBakedGLBReady] = useState(false);
    let unbakedGLBPresignedURL = "";
    const [previewGLBDownloadURL, setPreviewGLBDownloadURL] = useState<string>('');
    const [isLoading, setIsLoading] = useState(false);
    const isStartGeneratePreview=BuilderSelect.generatePreview().startGeneratePreview;
    const router = useRouter()
    // const onRoomModelLoaded = useCallback((boundingBox: THREE.Box3, floorGeometry: any,
    //     floorMesh?: THREE.Mesh) => {
    //     console.log('debug- roomviewrenderer- onRoomModelLoaded');
    //     roomModelLoaded();
    //     const center = new THREE.Vector3();
    //     boundingBox.getCenter(center);
    //     centerRef.current = center;
    //     floorGeometryRef.current = floorGeometry;
    //     floorMeshRef.current = floorMesh;
    //     setRoomBoundingBox(boundingBox);
    // }, []);

    console.log('debug- roomviewrenderer..');
    // const getWalls = () => {
    //     const childComps: JSX.Element[] = [];
    //     twoDRoomLayout.walls.forEach(wallMesh => {
    //         childComps.push(<ThreeDLayoutWallRenderer wallMesh={wallMesh} />);
    //     })
    //     return childComps;
    // }

    const roomWidth = twoDRoomLayout.boundingRect.width * meter_factor;
    const roomDepth = twoDRoomLayout.boundingRect.height * meter_factor;
    const roomHeight = 2.5;
    const roomBoundingBox = new THREE.Box3();
    roomBoundingBox.min = new THREE.Vector3(0, -roomHeight / 2, 0);
    roomBoundingBox.max = new THREE.Vector3(roomWidth, roomHeight / 2, roomDepth);

    useEffect(() => {
        const roomWidth = twoDRoomLayout.boundingRect.width * meter_factor;
        const roomDepth = twoDRoomLayout.boundingRect.height * meter_factor;
        const roomHeight = 2.5;
        const roomBoundingBox = new THREE.Box3();
        roomBoundingBox.min = new THREE.Vector3(-roomWidth / 2, -roomHeight / 2, -roomDepth / 2);
        roomBoundingBox.max = new THREE.Vector3(roomWidth / 2, roomHeight / 2, roomDepth / 2);
        dispatch(builderActions.updateRoomBoundingBox({
            roomBoundingBox: roomBoundingBox
        }));
        !isEditFlow && dispatch(builderActions.addProductToProject({
            productId: twoDRoomLayout.floorTextureId,
            surfaceType: SurfaceType.FLOOR,
            surfaceId: SurfaceType.FLOOR,
            type: ProductPlacementType.Texture
        }));
    }, []);

    const vertices = twoDRoomLayout.vertices;
    let centerOffsetX = Infinity, centerOffsetY = Infinity;
    vertices.forEach(vertex => {
        if (vertex.x < centerOffsetX) {
            centerOffsetX = vertex.x;
        }
        if (vertex.y < centerOffsetY) {
            centerOffsetY = vertex.y;
        }
    })
    const centerPoint = { x: twoDRoomLayout.centerPoint.x + centerOffsetX, y: twoDRoomLayout.centerPoint.y + centerOffsetY };
    const roomShape = new THREE.Shape();
    roomShape.moveTo((vertices[0].x - centerPoint.x) * meter_factor, (vertices[0].y - centerPoint.y) * meter_factor);
    for (let i = 1; i < vertices.length; i++) {
        roomShape.lineTo((vertices[i].x - centerPoint.x) * meter_factor, (vertices[i].y - centerPoint.y) * meter_factor);
    }
    const floorGeometry = new THREE.ShapeGeometry(roomShape);

    const dotMaterial = new THREE.PointsMaterial({ size: 0.3, color: 0xff0000 });
    vertices.forEach(vertex => {
        const dotGeometry = new THREE.BufferGeometry();
        dotGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array([(vertex.x - centerPoint.x) * meter_factor, -1.5, (vertex.y - centerPoint.y) * meter_factor]), 3));
        const dot = new THREE.Points(dotGeometry, dotMaterial);
        //scene.add(dot);
    });

    const floorPos = new THREE.Vector3((centerPoint.x) * meter_factor, -roomHeight / 2 - 0.01, centerPoint.y * meter_factor);
    const floorRot = new THREE.Euler(Math.PI / 2, 0, 0);
    const wallPosY = is2DView ? -1.35 : 0;

    const lines = useMemo(() => {
        const grids: any = [];
        for (let i = -35; i < 35; i = i + 0.1) {
            grids.push(<Line
                points={[[-35, 0, i], [35, 0, i]]}
                color="black"
                lineWidth={0.15}
            />);
            grids.push(<Line
                points={[[i, 0, -35], [i, 0, 35]]}
                color="black"
                lineWidth={0.15}
            />);
        }
        for (let i = -35; i < 35; i = i + 0.4) {
            grids.push(<Line
                points={[[-35, 0, i], [35, 0, i]]}
                color="black"
                lineWidth={0.4}
            />);
            grids.push(<Line
                points={[[i, 0, -35], [i, 0, 35]]}
                color="black"
                lineWidth={0.4}
            />);
        }
        return grids;
    }, []);

    console.log('mem :: render- ThreeDRoomLayoutRenderer');

    function exportAndUploadGLB() {
        if (!scene) return;

        const exporter = new GLTFExporter();

        // Create a new scene or group to hold only the objects you want to export
        const exportScene = scene.clone();
        
        // Example: Add specific objects (e.g., meshes) to this new scene
        exportScene.traverse((object) => {
            if (object instanceof THREE.Mesh) {
                // Example: Include only certain objects by name or custom condition
                if (object.geometry.type == "PlaneGeometry" || object.geometry.type == "LineGeometry") {
                    object.visible = false;
                }
            }
            if (object.type == "GridHelper") {
                object.visible = false
            }
        });

        exporter.parse(
            exportScene, (gltf) => {
                // gltf is an ArrayBuffer
                console.log("Debug -> GLB export successful");
                
                uploadToS3(gltf);
            }, function (error) {
                console.log('An error happened', error);
            },
            { 
                binary: true,
                onlyVisible: true
            }    
        );
    }
    const arrayBufferToBlob = (buffer: any) => {
        return new Blob([buffer], { type: 'application/octet-stream' });
    };
    const uploadToS3 = async (gltfBuffer: any) => {
        const blob = arrayBufferToBlob(gltfBuffer);
        
        // Assume you have a function to get the presigned URL from your backend
        const presignedUrl = unbakedGLBPresignedURL;
        
        try {
            const response = await fetch(presignedUrl, {
                method: 'PUT',
                body: blob,
                headers: {
                    'Content-Type': 'model/gltf-binary',
                },
            });
            console.log('Upload Response', response);
            if (response.ok) {
                console.log('Upload successful');
                dispatch(builderActions.startGeneratePreview({startGeneratePreview:true }));

                router.push('/projects')
                // setIsBakedGLBReady(true);
                setIsLoading(false);

                // fetchPreviewGenerationStatusRequest();
            } else {
                console.error('Upload failed');
            }
        } catch (error) {
            console.error('Error uploading to S3:', error);
        }
    };

    useEffect(() => {
        if (isStartGeneratePreview) {
            setIsLoading(true);
            handlePutRequest();
            // downloadGLB();
        }
    }, [isStartGeneratePreview, scene]);

    const fetchPreviewGenerationStatusRequest = async () => {
        const projectID = urlParams.projectId; //'ff1dbbc6-bc99-41b2-b3ae-95a06a18299d';
        const customerID = getUserId();
        const url = 'https://d221a61rb87vel.cloudfront.net/v1/api/projects/getPreview/' + projectID; 
    
        try {
          const res = await axios.get(url, {
            headers: {
              'Content-Type': 'application/json',
              'Customer-Id': customerID //"b0a4cdea-5e58-46e0-a345-8c7bffc1591e"
            }
          });
          
          console.log('Get Preview Response:', res.data);
          if (res?.data?.previewStatus&&res?.data?.previewImageUrl) {
            setPreviewGLBDownloadURL(res.data.previewImageUrl);
            setIsBakedGLBReady(true);
            setIsLoading(false);
          }
          
        } catch (error) {
          console.log('Error making GET request', error);
        }

    };

    useEffect(() => {
        if (isPreviewMode) {
            // dispatch(actions.setViewMode({ viewMode: 'preview' }))
            setIsLoading(true);
            fetchPreviewGenerationStatusRequest();
        }
    }, [isPreviewMode])
    const handlePutRequest = async () => {
        const projectID = urlParams.projectId; //'ff1dbbc6-bc99-41b2-b3ae-95a06a18299d';
        const customerID = getUserId();
        const url = 'https://d221a61rb87vel.cloudfront.net/v1/api/projects/generatePreview/' + projectID; 
        
        // Data you want to send in the request body
        const data = { };
    
        try {
          const res = await axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              'Customer-Id': customerID //"b0a4cdea-5e58-46e0-a345-8c7bffc1591e"
            }
          });
          //setResponse(res.data);
          console.log('Generate Preview Response:', res.data);
          unbakedGLBPresignedURL = res.data.unbakedImageSignedUrl;
        //   setPreviewGLBDownloadURL('https://d221a61rb87vel.cloudfront.net/projectImages/b0a4cdea-5e58-46e0-a345-8c7bffc1591e1e2864f8-749c-4186-8251-3c888fc3a20d_previewImage.glb'); //setPreviewGLBDownloadURL(res.data.previewImageUrl);
          
          exportAndUploadGLB(); // <-- Working
        } catch (error) {
          console.error('Error making PUT request', error);
        }
    };

    return <>
        {(!isPreviewMode) && <group
            position={[-centerPoint.x * meter_factor, -1, -centerPoint.y * meter_factor]}
            rotation={[0, 0, 0]}
            visible={true}
        >

            <group
                position={[0, wallPosY, 0]}
            >
                <ThreeDLayoutWallsRenderer walls={twoDRoomLayout.walls} />
            </group>
            <Floor
                boundingBox={roomBoundingBox}
                toggleControls={toggleControls}
                updateCameraPosition={updateCameraPosition}
                geometry={floorGeometry}
                floorPos={floorPos}
                floorRot={floorRot}
                roomOffsetX={centerPoint.x * meter_factor}
                roomOffsetZ={centerPoint.y * meter_factor}
            />
        </group>}
        {isPreviewMode && isBakedGLBReady && <group>
            <BakedRoomModel url={previewGLBDownloadURL} />
        </group>}

    </>
}

export default memo(ThreeDRoomLayoutRenderer);